import { useEffect, useState } from 'react'
import DashboardLayout from '../../../layouts/Dashboard'
import { useLoading } from '../../../hooks/LoadingContext'
import api from '../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../utils/errorApi'
import { Card, Col, Container, Row } from 'react-bootstrap'

import styles from './styles.module.css'

interface IConnection {
  freeConnections: number
  pendingConnections: number
  usedConnections: number
}

interface IHealth {
  displayName: string
  health: {
    healthy: boolean
    message: string
  }
  meta: Array<IConnection>
}

function Inicio() {
  const { setIsLoading } = useLoading()
  const [health, setHealth] = useState<IHealth>()

  useEffect(() => {
    async function loadData() {
      setIsLoading(true)

      try {
        const { data } = await api.get('/admin/app/health/connection-pool')

        setHealth(data)
      } catch (error) {
        console.error(error)
        toast.error(errorApi(error, 'Falha ao buscar os dados! Atualize a página.'))
      }

      setIsLoading(false)
    }

    loadData()
  }, [setIsLoading])

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Início">
      <Container>
        <Row>
          <h2 className="text-center my-3">Saúde do sistema</h2>
        </Row>

        <Row className="mb-2">
          <h4>Conexões com o banco de dados</h4>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Card
              className={`${styles.card}`}
              style={{
                backgroundColor: health?.health.healthy
                  ? 'rgba(0, 255, 0, 0.2)'
                  : 'rgba(255, 0, 0, 0.2)',
              }}
            >
              <Card.Body>
                <Card.Title>Status</Card.Title>
                <Card.Text>{health?.health.healthy ? 'Saudável' : 'Problema'}</Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="mb-3">
            <Card className={`${styles.card}`}>
              <Card.Body>
                <Card.Title>Conexões</Card.Title>
                <ul>
                  <li>Conexões livres: {health?.meta[0].freeConnections}</li>
                  <li>Conexões pendentes: {health?.meta[0].pendingConnections}</li>
                  <li>Conexões usadas: {health?.meta[0].usedConnections}</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </DashboardLayout>
  )
}

export default Inicio
